<script>
import Component from '~/sites/shop/pages/aboutPurchase/index'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/vse-o-nakupu',
      de: '/alle-hilfethemen',
      en: '/about-purchase',
      sk: '/vsetko-o-nakupe',
    },
  },
}
</script>
